/**
 * Shape Style Helpers
 *
 * Utility functions for converting shape styles to MapLibre properties.
 * Reuses line style helpers for border dash arrays.
 *
 * @module components/map/GeometryRenderer/ShapeRenderer/utils/shapeStyleHelpers
 */

import { LineStyle } from '../../../../../types/geometry';

/**
 * Convert LineStyle enum to MapLibre dash array for shape borders
 *
 * Same as line dash arrays - reuses the pattern.
 *
 * @param borderStyle - The border style enum value
 * @returns Dash array for MapLibre line-dasharray property
 */
export function getBorderDashArray(borderStyle: LineStyle | undefined): number[] {
  switch (borderStyle) {
    case LineStyle.Solid:
      return [1, 0];
    case LineStyle.Dashed:
      return [4, 2];
    case LineStyle.Dotted:
      return [1, 2];
    default:
      return [1, 0]; // Default to solid
  }
}
